import {useSelector} from 'react-redux';
import {HouseQueAppState} from '../../../houseque';

export const useEstimates = () => {
  const estimates = useSelector((store: HouseQueAppState) => {
    return store.deals.selectedDealEstimates;
  });
  return estimates;
};
